import { GET_SPECIFIC_BOOKMARK, IS_LOADING, LIKE_UP } from "./postActionsTypes";

const INITIAL_STATE = {
  specificBookmark: "",
  isLoading: false,
  likes: 0
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SPECIFIC_BOOKMARK:
      return {
        ...state,
        specificBookmark: action.payload,
        likes: action.payload.likes
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    case LIKE_UP:
      return {
        ...state,
        likes: action.payload
      };
    default:
      return state;
  }
};
